import { add, contains } from "@fluorescent/dom";
import getMediaQuery from "@/lib/media-queries";
const classes = {
  small: 'section--small',
  extraSmall: 'section--extra-small',
};

const mobileSizes = {
  default: 40,
  small: 40,
  extraSmall: 28
};

const desktopSizes = {
  default: 56,
  small: 120,
  extraSmall: 28
};

export default (node, options = { instant: false }) => {
  let threshold = 0;
  if (!options.instant) {
    // Get section size, this determines how much margin the section has
    let sectionSize = 'default';
    if (contains(node, classes.small)) {
      sectionSize = 'small';
    } else if (contains(node, classes.extraSmall)) {
      sectionSize = 'extraSmall';
    }

    // Get the margin amount based on section sizes and screen width
    let margin = 56;
    if (window.matchMedia(getMediaQuery("not-small")).matches) {
      margin = desktopSizes[sectionSize];
    } else {
      margin = mobileSizes[sectionSize];
    }

    threshold = Math.min(margin / node.offsetHeight, 0.5);
  }

  const observer = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        add(node, "is-visible");

        if (typeof options.cb === 'function') {
          options.cb();
        }

        observer.disconnect();
      }
    },
    { threshold: threshold }
  );

  observer.observe(node);

  return {
    destroy() {
      observer?.disconnect();
    },
  };
};
